// extracted by mini-css-extract-plugin
module.exports = {"FiltroWrapper":"styles_FiltroWrapper__3pJrR"};